<form (submit)="onSubmit($event)" class="uploader__form">
    <input pInputText [disabled]="disabled" type="file" name="file" (change)="onChange($event)" class="form-control uploader__input">
    <div *ngIf="error" class="ui-g-2" pTooltip="{{errorDesc}}">
        <div class="ui-g-12 label label-danger  fa fa-fw fa-exclamation"> </div>
    </div>
    <p-progressSpinner *ngIf="uploading" [style]="{width: '25px', height: '25px'}" strokeWidth="8"></p-progressSpinner>
    <button *ngIf="!uploading" type="submit" class="btn btn-primary uploader__button">Upload</button>
</form>